// Heap event names, in one place so a rename stays a one-line change and the
// Heap dashboards keep matching. Fired via the telemetry lib's trackHeapEvent.
export const ANALYTICS_EVENTS = {
  PROMOTION_PUBLISH: "Promotion_Publish",
  PRICECHECK_EXPORT: "PriceCheck_Export",
  ARI_BULK_UPDATE: "ARI_BulkUpdate",
  PROPERTY_SWITCH: "Property_Switch",
  LOGIN_SUCCESS: "Login_Success",
  DAILY_BREAKDOWN_EXPANDED: "reservation_report_daily_breakdown_expanded",
  DAILY_BREAKDOWN_COLLAPSED: "reservation_report_daily_breakdown_collapsed",
};
